<template>
  <div class="goods-container">
    <ul
      class="cap-goods-layout__container"
      :class="{
        'show-column': goodShowType === 'twoColumn',
        'three-column': goodShowType === 'threeColumn',
        scroll: goodShowType === 'scroll',
      }"
      :style="{ paddingLeft: padding + 'px', paddingRight: padding + 'px' }"
    >
      <li
        class="cap-goods-layout__wrapper"
        :class="{ radius: borderRadius }"
        v-for="(v, i) in goodsList"
        :key="i"
      >
        <div
          class="cap-goods-layout__item"
          :class="{ radius: borderRadius }"
          :style="{ margin: marginBottom + 'px' }"
        >
          <div
            class="cornor-logo"
            v-if="showLogo && logoType !== '自定义'"
            :style="{ left: marginBottom + 'px', top: marginBottom + 'px' }"
          >
            {{ logoType }}
          </div>
          <div
            class="custom-logo"
            v-if="showLogo && logoType === '自定义'"
            :style="{ left: marginBottom + 'px', top: marginBottom + 'px' }"
          >
            <img :src="logoUrl" alt="logo" />
          </div>
          <div class="cap-goods__photo">
            <div
              class="cap-goods__image-wrap"
              :class="{
                'height351': goodShowType === 'big',
                'height171': goodShowType === 'twoColumn',
                'height110': goodShowType === 'threeColumn',
                'height102': goodShowType === 'scroll',
              }"
            >
              <img
                :src="v.spuMainPic"
                class="img"
                alt
                :class="{ radius: borderRadius }"
              />
            </div>
          </div>
          <div class="cap-goods-layout__info">
            <div class="cap-goods-layout__info-title">
              <div class="goods-title" :class="{ bold: titleBold }">
                {{ v.wxshopSpuName }}
              </div>
              <!-- <div class="sub-title" v-if="showSubTitle">{{ v.subTitle }}</div> -->
            </div>
            <div
              class="cap-goods-layout__info-price flex flex-between item-center"
            >
              <div class="price-info flex item-end">
                <div class="sale-price flex">
                  <div
                    class="cap-theme-view"
                    v-if="showPrice"
                    :class="{ bold: titleBold }"
                  >
                    <span class="price-tag">￥</span>
                    {{ v.showPrice }}
                  </div>
                  <div
                    class="sale-price__origin"
                    v-if="showSubPrice"
                    :class="{ bold: titleBold }"
                  >
                    ￥{{ v.markingPrice }}
                  </div>
                </div>
                <div class="sale-num" v-if="showSaleNum">
                  销量：{{ v.saleNum }}
                </div>
              </div>
              <div class="cap-goods-layout__buy-btn-wrapper" v-if="showCart">
                <span class="cart hmicon icon-xiaochengxu-gouwuche"></span>
              </div>
            </div>
          </div>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  props: {
    showSubTitle: {
      type: Boolean,
      default: true,
    },
    showPrice: {
      type: Boolean,
      default: true,
    },
    showSubPrice: {
      type: Boolean,
      default: false,
    },
    showSaleNum: {
      type: Boolean,
      default: false,
    },
    showCart: {
      type: Boolean,
      default: true,
    },
    showLogo: {
      type: Boolean,
      default: true,
    },
    borderRadius: {
      type: Boolean,
      default: false,
    },
    titleBold: {
      type: Boolean,
      default: false,
    },
    padding: {
      type: Number,
      default: 5,
    },
    marginBottom: {
      type: Number,
      default: 5,
    },
    goodShowType: {
      type: String,
      default: "big",
    },
    logoType: {
      type: String,
      default: "HOT",
    },
    logoUrl: {
      type: String,
      default: "",
    },
    goodsList: {
      type: Array,
      default: () => [],
    },
  },
  components: {},
  data() {
    return {};
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {},
  methods: {},
};
</script>
<style lang="scss" scoped>
.cap-goods__image-wrap {
  position: relative;
  overflow: hidden;
  max-height: 500px;
  .img {
    width: 100%;
  }
  .img.radius {
    border-top-left-radius: 5px;
    border-top-right-radius: 5px;
  }
}

.goods-container {
  overflow: hidden;
}

.cap-goods-layout__wrapper {
  position: relative;
  min-height: 50px;
  color: #333;
  box-sizing: border-box;
  overflow: hidden;
  line-height: 16px;
  .cap-goods-layout__item {
    background-color: #fff;
    margin: 5px;
    &.radius {
      border-radius: 10px;
    }
  }
  &.radius {
    border-bottom-left-radius: 10px;
    border-bottom-right-radius: 10px;
  }
}

.cornor-logo {
  position: absolute;
  z-index: 100;
  top: 13px;
  left: 10px;
  width: 66px;
  height: 26px;
  text-align: center;
  line-height: 26px;
  background: linear-gradient(270deg, #ff9292, #e50000);
  border-radius: 19px 13px 13px 0px;
  color: #fff;
}

.custom-logo {
  position: absolute;
  z-index: 100;
  top: 13px;
  left: 0;
  width: 66px;
}

.bold {
  font-weight: bold !important;
}

.cap-goods-layout__container {
  &.show-column {
    display: flex;
    flex-wrap: wrap;
    flex-direction: flex-start;
    justify-content: space-between;
    .cap-goods-layout__wrapper {
      width: 50%;
    }
  }
  &.three-column {
    // column-count: 3;
    // column-gap: 5px;
    // display: inline-block;
    display: flex;
    flex-wrap: wrap;
    flex-direction: flex-start;
    .cap-goods-layout__wrapper {
      width: 33.33%;
    }
  }
  &.scroll {
    display: flex;
    flex-wrap: nowrap;
    -webkit-overflow-scrolling: touch;
    padding-bottom: 10px;
    margin-bottom: -10px;
    overflow-x: auto;
    overflow-y: hidden;
    white-space: nowrap;
    width: 100%;
    .cap-goods-layout__wrapper {
      flex-basis: 112px;
      flex-shrink: 0;
      white-space: nowrap;
      white-space: nowrap;
    }
  }
}

.cap-goods-layout__info {
  padding: 0 10px;
  position: relative;
  .cap-goods-layout__info-title {
    margin: 10px 0 0;
    .goods-title {
      font-size: 14px;
      line-height: 20px;
      max-height: 20px;
      margin-bottom: 5px;
      word-break: break-all;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 1;
      -webkit-box-orient: vertical;
    }
    .sub-title {
      font-size: 12px;
      line-height: 16px;
      color: #999;
      height: 16px;
      word-break: break-all;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 1;
      -webkit-box-orient: vertical;
    }
  }
}

.cap-goods-layout__info-price {
  height: 44px;
  .cart {
    color: rgb(255, 68, 68);
    font-size: 18px;
  }

  .sale-price {
    color: #f44;
    height: 16px;
    line-height: 16px;
    font-size: 16px;
    word-break: break-all;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    .price-tag {
      font-size: 12px;
      margin-right: 2px;
    }

    .sale-price__origin {
      height: 12px;
      line-height: 12px;
      font-size: 12px;
      color: #999;
      margin-top: 2px;
      font-weight: 400;
      text-decoration: line-through;
    }
  }
}

.sale-num {
  font-size: 12px;
  margin-left: 5px;
  color: #999;
}

.height351 {
  height: 351px;
}
.height171 {
  height: 171px;
}
.height110 {
  height: 110px;
}
.height102 {
  height: 102px;
}
</style>
